import { atom, useAtom } from 'jotai';

const navigationMinimizedAtom = atom<boolean>(true);

const useNavigationMinimized = () => useAtom(navigationMinimizedAtom);

export default useNavigationMinimized;
